import getConfig from 'next/config';

// appends to be that path name
// and basePath use the same values
// this may not always be the case...
type TProjects =
  | 'team'
  | 'concordia'
  | 'careerprofile'
  | 'school'
  | 'video'
  | 'photography'
  | 'association';

type TBasePaths =
  | '/team'
  | '/concordia'
  | '/careerprofile'
  | '/school'
  | '/video'
  | '/photography'
  | '/association';

interface IMPNextConfig {
  publicRuntimeConfig: {
    /**
     * dev for local
     * development for hosted QA environments
     */
    appEnv: 'production' | 'dev' | 'development' | 'staging';
    /**
     * Based on other code i've seen this is like 'mp-13431' when on a hosted branch
     */
    subdomain?: 'local' | string;
    /**
     * Represents the project that is building
     * '' Should only be a value when running jest
     */
    appName: TProjects | '';

    /**
     * Value passed to sentry
     * '' Should only be a value when running jest
     */
    sentryDsn: '' | string;

    basePath: TBasePaths | '';
  };
}

const defaultConfig: IMPNextConfig = {
  publicRuntimeConfig: {
    appEnv: 'production',
    subdomain: '',
    appName: '', // what makes sense as a fallback here?
    sentryDsn: '',
    basePath: ''
  }
};

const getNextConfig = (): IMPNextConfig => getConfig() ?? { ...defaultConfig };

export default getNextConfig;
